import { FilterFilled } from '@ant-design/icons';

import AppTableFilterPopup from './AppTableFilterPopup';

export default function getColumnFilterProps({ dataIndex, filters, title, onFilter }) {
  return {
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, close }) => (
      <AppTableFilterPopup
        dataIndex={dataIndex}
        filters={filters}
        selectedKeys={selectedKeys}
        title={title}
        handleOnChange={value => {
          setSelectedKeys(value);
          confirm(false);
        }}
        handleReset={() => {
          setSelectedKeys([]);
          confirm();
          close();
        }}
        handleConfirm={close}
      />
    ),
    filterIcon: filtered => <FilterFilled style={{ color: filtered ? '#000000' : undefined, fontSize: '12px' }} />,
    onFilter: onFilter
      ? onFilter
      : (value, record) => {
          if (dataIndex && record[dataIndex]) {
            const preparedValue = typeof value === 'string' ? value.toString().toLowerCase() : value;
            return record[dataIndex].toString().toLowerCase().includes(preparedValue);
          }
        }
  };
}
